import PropTypes from "prop-types";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, Paper, Typography } from "@mui/material";
const PageHeader = ({ title, btn, subTitle }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {btn.back && (
          <Button
            type="button"
            onClick={btn.back}
            sx={{
              mr: 1,
              p: 0.5,
              minWidth: "auto",
            }}
          >
            <ArrowBackIcon />
          </Button>
        )}
        <Typography variant="h6">
          {title}
          <Typography>{subTitle}</Typography>
        </Typography>
      </Box>
      <Box>
        {/* {btn.btn1 && (
          <Button
            type="button"
            variant={btn.btn1Type}
            onClick={btn.btn1CallBack}
          >
            {btn.btn1Text}
          </Button>
        )} */}
        {btn.show && (
          <Button type="button" variant={btn.type} onClick={btn.callBack}>
            {btn.text}
          </Button>
        )}
      </Box>
    </Paper>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  btn: PropTypes.object,
};

export default PageHeader;
